const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach(
      (button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeMenuDrawer(event, detailsElement);
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    if (!this.classList.contains('menu-loaded')) {
      this.renderMenu();
    }
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  };
  renderMenu() {
    let targetContainer = document.querySelector(
      '.menu-drawer__navigation > .menu-drawer__menu'
    );
    let code = '';
    if (menu_mobile.links.length && targetContainer) {
      code += this.renderLinkMenu(menu_mobile.links);
      code += this.renderLinkMenu(menu_mobile.linksSecond);
    }
    targetContainer.innerHTML = code;
    this.classList.add('menu-loaded');
    this.bindEvents();
  }
  renderLinkMenu(linkMenu) {
    let code = '';
    for (const [index, link] of linkMenu.entries()) {
      code += '<li>';

      if (link.children.length) {
        let hasGrandchildren = link.levels === 2;
        let hasNoGrandchildren = !hasGrandchildren;

        code += `	
          <details id="Details-menu-drawer-menu-item-${index}">	
            <summary	
              id="HeaderDrawer-${link.handle}"	
              class="menu-drawer__menu-item list-menu__item link link--text focus-inset${
                link.child_active ? 'menu-drawer__menu-item--active' : ''
              }"	
            >	
              <h2>${link.title}</h2>	
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-menu icon-menu-close">	
                <path d="M1 8.5L16 8.5M8.5 16L8.5 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>	
              </svg>	
              <svg width="19" height="4" viewBox="0 0 19 4" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-menu icon-menu-open">	
                <path d="M2 2H17" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>	
              </svg>	
            </summary>	
            <div	
              id="link-${link.handle}"	
              class="menu-drawer__submenu has-submenu gradient motion-reduce"	
              tabindex="-1"	
            >	
              <div class="menu-drawer__inner-submenu ${hasNoGrandchildren ? 'menu-drawer__inner-submenu--no-grandchildren' : ''}">	
                <a class="button button--primary button--size_large focus-inset" href="${
                  link.url
                }">	
                  Shop All	
                  ${menu_mobile.icon_arrow}	
                </a>	
                <ul class="menu-drawer__menu list-menu" role="list" tabindex="-1">	
                  ${link.children
                    .map(
                      (childlink) => `	
                    <li>	
                      ${
                        childlink.children && childlink.children.length
                          ? `	
                        <div class="menu-drawer__menu-item menu-drawer__menu-item-with-grandchildren link link--text list-menu__item focus-inset">	
                          ${childlink.title}	
                        </div>	
                        <div class="menu-drawer__submenu has-submenu gradient motion-reduce">	
                          <ul	
                            class="menu-drawer__menu menu-drawer__pages-menu list-menu"	
                            role="list"	
                            tabindex="-1"	
                          >	
                            ${
                              childlink.children.length &&
                              childlink.children
                                .map(
                                  (grandchildlink) => `	
                              <li>	
                                <div	
                                  id="HeaderDrawer-${link.handle}-${
                                    childlink.handle
                                  }-${grandchildlink.handle}"	
                                  class="menu-drawer__menu-item page-card link link--text list-menu__item focus-inset ${
                                    grandchildlink.current
                                      ? 'menu-drawer__menu-item--active'
                                      : ''
                                  }"	
                                  ${
                                    grandchildlink.current
                                      ? 'aria-current="page"'
                                      : ''
                                  }	
                                >	
                                  ${
                                    grandchildlink.image_url
                                      ? `	
                                    <img src="${grandchildlink.image_url}" alt="${grandchildlink.title}" width="106" height="106" loading="lazy" />	
                                  `
                                      : ''
                                  }	
                                  <div class="page-card--content">	
                                    <h5 class="page-card--title">${
                                      grandchildlink.title
                                    }</h5>	
                                    <a href="${
                                      grandchildlink.url
                                    }" class="button button--secondary button--size_small">Read More ${
                                    menu_mobile.icon_arrow
                                  }</a>	
                                  </div>	
                                </div>	
                              </li>	
                            `
                                )
                                .join('')
                            }	
                          </ul>	
                        </div>	
                      `
                          : `	
                      ${
                        childlink.url.includes('pet')
                          ? '<span class="menu-seperator"></span>'
                          : ''
                      }	
                        <a	
                          id="HeaderDrawer-${link.handle}-${childlink.handle}"	
                          data-title="${childlink.title}"
                          href="${childlink.url}"	
                          class="menu-drawer__menu-item link link--text list-menu__item ${
                            childlink.image
                              ? 'menu-drawer__menu-item--has-image'
                              : ''
                          } focus-inset ${
                              childlink.current
                                ? 'menu-drawer__menu-item--active'
                                : ''
                            }"	
                          ${childlink.current ? 'aria-current="page"' : ''}	
                        >	
                          ${childlink.image ? childlink.image : ''}	
                          ${childlink.title}	
                        </a>	
                      `
                      }	
                    </li>	
                  `
                    )
                    .join('')}	
                </ul>	
              </div>	
            </div>	
          </details>	
        `;
      } else {
        code += `	
          <a	
            id="HeaderDrawer-${link.handle}"	
            href="${link.url}"	
            class="menu-drawer__menu-item list-menu__item link link--text focus-inset ${
              link.current ? 'menu-drawer__menu-item--active' : ''
            }"	
            ${link.current ? 'aria-current="page"' : ''}	
          >	
            <h2>${link.title}</h2>	
          </a>	
        `;
      }
      code += '</li>';
    }
    return code;
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
            observedElements();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function observedElements() {
  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);

      const dataObservedElements = document.querySelectorAll('[data-observe]');
      dataObservedElements.forEach((el) => {
        if (el === entry.target) {
          const dataUrl = el.dataset.observe;
          fetch(dataUrl)
            .then((response) => response.text())
            .then((text) => {
              el.innerHTML = text;
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (document.querySelector('.shimmer')) {
                document.querySelector('.shimmer').classList.remove('shimmer');
              }
            });
        }
      });
    });
  };

  const observedElements = document.querySelectorAll('[data-observe]');
  if (observedElements.length > 0) {
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '350px',
    });
    observedElements.forEach((element) => observer.observe(element));
  }
}

observedElements();

const MegaMenu = {
  init() {
    this.meganavs = document.querySelectorAll('.custom-mega-nav');
    if (window.innerWidth > 750) {
      this.loadFirst();
      this.bindEvents();
    }
  },
  bindEvents() {
    this.meganavs.forEach((meganav_item) => {
      const meganav_children = meganav_item.querySelectorAll(
        '.custom-mega-nav__nav-item'
      );

      meganav_children.forEach((meganav_child, index) => {
        meganav_child.addEventListener('mouseenter', function () {
          if (!this.classList.contains('active')) {
            meganav_children.forEach((item) => {
              item.classList.remove('active');
            });
            this.classList.add('active');
          }
        });
      });
    });
  },
  loadFirst() {
    mega_nav.forEach((children, index) => {
      document.getElementById('menu-' + index).innerHTML =
        MegaMenu.loadChildren(children);
      MegaMenu.loadFirstPage(children[0]);
    });
    this.loadOnHover();
  },
  loadFirstPage(child) {
    const id = child.url.split('/').slice(-1)[0];
    const first_element = document.getElementById(id);

    first_element.innerHTML = this.loadGrandchild(
      child.children,
      first_element
    );
    MegaMenu.setContent(first_element, first_element.outerHTML);
    first_element.parentNode.classList.add('active');
  },
  loadChildren(children) {
    let html = '';
    children.forEach((childlink) => {
      if (childlink.url != undefined) {
        if (childlink.title.includes('Shop All')) {
          childlink.bold = 'button button--primary button--size_large ';
          childlink.title +=
            '<svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-arrow"><path d="M3.512 1.356L5.163 0.211999C5.579 0.887999 5.98633 1.499 6.385 2.045C6.78367 2.58233 7.19533 3.06333 7.62 3.488C8.05333 3.91267 8.51267 4.30267 8.998 4.658V4.736C8.51267 5.09133 8.05333 5.48567 7.62 5.919C7.19533 6.34367 6.78367 6.82467 6.385 7.362C5.98633 7.89933 5.579 8.51033 5.163 9.195L3.512 8.051C3.88467 7.48767 4.27033 7.00233 4.669 6.595C5.07633 6.179 5.488 5.828 5.904 5.542C6.32 5.256 6.723 5.02633 7.113 4.853C7.503 4.67967 7.86267 4.554 8.192 4.476V4.918C7.86267 4.84 7.503 4.71867 7.113 4.554C6.723 4.38067 6.32 4.151 5.904 3.865C5.488 3.579 5.07633 3.228 4.669 2.812C4.27033 2.396 3.88467 1.91067 3.512 1.356ZM0.34 3.592H3.395C4.10567 3.592 4.77733 3.63533 5.41 3.722C6.05133 3.8 6.64067 3.904 7.178 4.034L8.27 4.697L7.178 5.36C6.64067 5.49 6.05133 5.59833 5.41 5.685C4.77733 5.763 4.10567 5.802 3.395 5.802H0.34V3.592Z" fill="currentColor"/></svg>';
        }
        childlink.handle = childlink.url.split('/').slice(-1)[0];
        html += MegaMenu.getTemplate('child-container', childlink);
      }
    });

    return html;
  },
  loadGrandchild(grandchildren, where) {
    let html = '',
      count_build = 0;
    grandchildren.forEach((grandchild) => {
      let skipProduct = false;
      if (grandchild.url != undefined) {
        if (grandchild.url.includes('product')) {
          grandchild.handle = grandchild.url.split('/').slice(-1)[0];
          html += MegaMenu.getTemplate('grandchild-product', grandchild);
          fetch(grandchild.url + '.js')
            .then((response) => {
              if (response.ok) {
                return response.json();
              } else {
                document
                  .querySelectorAll('#product-' + grandchild.handle)
                  .forEach((item) => {
                    item.parentNode.remove();
                    skipProduct = true;
                  });
              }
            })
            .then((product) => {
              if (skipProduct) return false;

              let price =
                '$' +
                (product.price / 100)
                  .toFixed(2)
                  .toString()
                  .replace('.00', '')
                  .replace(',', '');

              if (product.price_varies == true) {
                price =
                  'from $' +
                  (product.price_min / 100)
                    .toFixed(2)
                    .replace('.00', '')
                    .replace(',', '');
              }

              const image = product.featured_image;
              const grandchild_container = document.querySelectorAll(
                '#product-' + grandchild.handle
              );
              grandchild_container.forEach((container) => {
                container.innerHTML = container.innerHTML
                  .replace('{{product_image}}', image)
                  .replace('<!--{{product_price}}-->Loading...', price);
              });
              if (where.parentNode.classList.contains('active')) {
                MegaMenu.setContent(where, where.outerHTML);
              }

              fetch(grandchild.url + '?view=swatches')
                .then((response) => response.text())
                .then((swatches) => {
                  const grandchild_container = document.querySelectorAll(
                    '#product-' + grandchild.handle
                  );
                  grandchild_container.forEach((container) => {
                    container.innerHTML = container.innerHTML.replace(
                      '<!--{{product_swatches}}-->Loading...',
                      swatches
                    );
                  });
                });
            });
        } else if (grandchild.url.includes('collection')) {
          html += MegaMenu.getTemplate('grandchild-collection', grandchild);
          fetch(grandchild.url + '?view=swatches')
            .then((response) => response.text())
            .then((swatches) => {
              const grandchild_container = document.querySelectorAll(
                '#collection-' + grandchild.handle
              );
              grandchild_container.forEach((container) => {
                container.innerHTML = container.innerHTML.replace(
                  '<!--{{collection_swatches}}-->Loading...',
                  swatches
                );
              });
            });
        } else {
          html += MegaMenu.getTemplate('grandchild-page', grandchild);
        }
        count_build++;
      }
    });
    if (count_build < 8) {
      for (let i = count_build; i < 8; i++) {
        // html += MegaMenu.getTemplate("empty", null);
      }
    }
    return html;
  },
  setContent(container, content) {
    let relativeMegaMenu = container.closest('.mega-menu');

    if (relativeMegaMenu) {
      relativeMegaMenu.querySelector(
        '.custom_meganav_details_container'
      ).innerHTML = content;
    }
  },
  loadOnHover() {
    document
      .querySelectorAll('.custom-mega-nav__nav-item')
      .forEach((sitenav_item) => {
        ['mouseenter', 'mouseover'].forEach((evt) => {
          sitenav_item.addEventListener(evt, function () {
            const grandchildren_container = this.querySelector('ul');
            const object = JSON.parse(this.dataset.object);
            if (grandchildren_container.innerHTML === '') {
              grandchildren_container.innerHTML = MegaMenu.loadGrandchild(
                object,
                grandchildren_container
              );
            }
            if (!this.classList.contains('active')) {
              MegaMenu.setContent(
                grandchildren_container,
                grandchildren_container.outerHTML
              );
            }
          });
        });
      });
  },
  getTemplate(name, object) {
    switch (name) {
      case 'child-container':
        return `
                <li class="custom-mega-nav__nav-item" ${!object.title.includes('Shop All') ? `data-title="${object.title}"` : ''} data-object='${JSON.stringify(
                  object.children
                )}'>
                  <a href="${object.url}"
                    class="site-nav__link site-nav__child-link site-nav__child-link--parent ${
                      object.bold
                    }"
                    ${object.current}
                  >
                    ${
                      object.url.includes('pet')
                        ? '<span class="menu-seperator"></span>'
                        : ''
                    }
                    <span class="site-nav__label eyebrow">
                        ${object.title}
                    </span>
                  </a>
                  <ul class="grid grid--2-col custom-mega-nav__nav-item__child"
                    id="${object.handle}"></ul>
                </li>`;
      case 'grandchild-product':
        const badge =
          object.badge != ''
            ? `<div class="card__badge eyebrow-small top"><span>${object.badge}</span></div>`
            : '';
        return `<li class="grid__item product-card-wrapper" ${object.current} id="product-${object.handle}">
                <div class="card card--standard card--media card--horizontal">
                <div class="card__inner ratio" style="--ratio-percent: 100%;">
                    <a href="${object.url}" class="card__media">
                      <div class="media media--transparent media--hover-effect">
                        <img src="{{product_image}}&width=106" alt="${object.title}" width="106" height="106" loading="lazy" />
                      </div>                 
                    </a>
                  </div>     
                    <div class="card__information">
                      <a href="${object.url}" class="full-unstyled-link">
                        <h4 class="card__heading">${object.title}</h4>
                        <div class="
                        price price--small">
                        <span class="price-item price-item--regular">
                          <!--{{product_price}}-->Loading...
                        </span>
                        </div>
                      </a>
                      <ul class="grid swatches swatches-card eyebrow-small">
                        <!--{{product_swatches}}-->Loading...
                      </ul>
                    </div>
                 </div>                  
            </li>`;
      case 'grandchild-collection':
        return `<li class="grid__item grid__item-collection product-card-wrapper"  ${
          object.current
        } id="collection-${object.handle}">
        <div class=" card card--standard card--media card--horizontal">

                  <div class="card__inner  ratio" style="--ratio-percent: 100%;">
                    <a href="${object.url}" class="card__media">
                      <div class="media media--transparent media--hover-effect">
                        <img src="${object.image}&width=106" alt="${
          object.title
        }" width="106" height="106" loading="lazy">
                      </div>
                    </a>
                  </div>

                    <div class="card__information">
                      <a href="${object.url}" class="full-unstyled-link">
                        <h4 class="card__heading">${object.title}</h4>
                        <div class="
                        price price--small">
                        <span class="price-item price-item--regular">
                          From ${object.min_price
                            .replace('.00', '')
                            .replace(',', '')}
                        </span>
                        </div>
                      </a>
                      <ul class="grid swatches swatches-card eyebrow-small">
                        <!--{{collection_swatches}}-->Loading...
                      </ul>
                    </div>
                  </a>
                </div>
            </li>`;
      case 'grandchild-page':
        return `<li class="mega-menu-page-li">
                <div class="custom-mega-nav__card custom-mega-nav__card__page page-card">
                  <div class="custom-mega-nav__card__image">
                    <img src="${object.image}&width=106" alt="${object.title}" width="106" height="106" loading="lazy" />
                  </div>

                  <div class="custom-mega-nav__card__details page-card--content">
                    <h3 class="card__heading">${object.page_title}</h3>

                    <a href="${object.url}"
                      class="button button--secondary button--size_small"
                      aria-label="Read More"
                      ${object.current}>
                      Read More
                      <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-arrow">
                        <path d="M3.512 1.356L5.163 0.211999C5.579 0.887999 5.98633 1.499 6.385 2.045C6.78367 2.58233 7.19533 3.06333 7.62 3.488C8.05333 3.91267 8.51267 4.30267 8.998 4.658V4.736C8.51267 5.09133 8.05333 5.48567 7.62 5.919C7.19533 6.34367 6.78367 6.82467 6.385 7.362C5.98633 7.89933 5.579 8.51033 5.163 9.195L3.512 8.051C3.88467 7.48767 4.27033 7.00233 4.669 6.595C5.07633 6.179 5.488 5.828 5.904 5.542C6.32 5.256 6.723 5.02633 7.113 4.853C7.503 4.67967 7.86267 4.554 8.192 4.476V4.918C7.86267 4.84 7.503 4.71867 7.113 4.554C6.723 4.38067 6.32 4.151 5.904 3.865C5.488 3.579 5.07633 3.228 4.669 2.812C4.27033 2.396 3.88467 1.91067 3.512 1.356ZM0.34 3.592H3.395C4.10567 3.592 4.77733 3.63533 5.41 3.722C6.05133 3.8 6.64067 3.904 7.178 4.034L8.27 4.697L7.178 5.36C6.64067 5.49 6.05133 5.59833 5.41 5.685C4.77733 5.763 4.10567 5.802 3.395 5.802H0.34V3.592Z" fill="currentColor"/>
                      </svg>  
                    </a>
                  </div>
                </div>
            </li>`;
      default:
        return 'wrong handle';
      case 'empty':
        return `<li><div style="height: 106px"></div></li>`;
      case 'product-swatches':
        return ``;
    }
  },
};

class ReadTime extends HTMLElement {
  constructor() {
    super();

    this.innerHTML = 'Calculating read time...';

    this.calculateReadTime(document);
  }

  calculateReadTime(doc) {
    let text = doc.querySelector('.article-template__content').innerText;
    const wpm = 225;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);
    this.innerText = `${time} min read`;
  }
}

customElements.define('read-time', ReadTime);

document.addEventListener('DOMContentLoaded', function () {
  MegaMenu.init();
});

class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.apiKey = 'pk_a51622549e4123bafd980723f5312c8b5b';
    this.listId = this.dataset.listId;
    this.form = this.querySelector('form');
    this.input = this.querySelector('input.field__input');
    this.success = this.querySelector('.newsletter-form__message--success');
    this.error = this.querySelector('.newsletter-form__message--error');

    if (this.form && this.input) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();

    this.options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        email: this.input.value,
        location: 'footer',
        list_id: this.listId,
      }),
    };

    fetch(
      `https://custom-checkouts.co.uk/titan/titan-klaviyo.php`,
      this.options
    )
      .then((response) => response.json())
      .then((response) => this.onSuccess(response))
      .catch((err) => this.onError(err));
  }

  onSuccess(response) {
    console.log(response);
    if (this.success && this.error) {
      this.success.classList.remove('hide');
      this.error.classList.add('hide');
    }

    this.input.setAttribute('aria-describedby', 'ContactFooter-success');

    this.input.removeAttribute('autofocus');
    this.input.removeAttribute('aria-invalid');
    this.input.removeAttribute('aria-describedby');

    console.log(response);
  }

  onError(err) {
    if (this.error && this.success) {
      this.error.classList.remove('hide');
      this.success.classList.add('hide');
    }

    this.input.setAttribute('autofocus', null);
    this.input.setAttribute('aria-invalid', true);
    this.input.setAttribute('aria-describedby', 'ContactFooter-error');

    this.input.removeAttribute('aria-describedby');

    console.error(err);
  }
}

customElements.define('klaviyo-form', KlaviyoForm);

document.addEventListener('DOMContentLoaded', (e) => {
  setTimeout(() => {
    let details = document.querySelectorAll('details');
    let chatra = document.querySelector('.chatra--webkit');

    if (chatra && details) {
      for (const detail of details) {
        detail.addEventListener('toggle', (e) => {
          chatra.style.display = e.target.open ? 'none' : 'block';
        });
      }
    }
  }, 1000);
});

document.addEventListener('DOMContentLoaded', function () {
  let targetSelector = '.cpb-product-price';

  let config = { childList: true, subtree: true, characterData: true };
  let contentObserver = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      let targetElement = document.querySelector(targetSelector);
      if (
        mutation.type === 'characterData' &&
        targetElement &&
        targetElement.classList.contains('cpb-product-price')
      ) {
        let PriceHtml = `<span class="atc-price">${targetElement.textContent}</span>
                    <span>|</span>
                    <span><span class="edit-on-variant-change">Add to cart</span>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" class="icon icon-arrow">
                        <path d="M4.784 1.592L6.816 0.183999C7.328 1.016 7.82933 1.768 8.32 2.44C8.81067 3.10133 9.31733 3.69333 9.84 4.216C10.3733 4.73867 10.9387 5.21867 11.536 5.656V5.752C10.9387 6.18933 10.3733 6.67467 9.84 7.208C9.31733 7.73067 8.81067 8.32267 8.32 8.984C7.82933 9.64533 7.328 10.3973 6.816 11.24L4.784 9.832C5.24267 9.13867 5.71733 8.54133 6.208 8.04C6.70933 7.528 7.216 7.096 7.728 6.744C8.24 6.392 8.736 6.10933 9.216 5.896C9.696 5.68267 10.1387 5.528 10.544 5.432V5.976C10.1387 5.88 9.696 5.73067 9.216 5.528C8.736 5.31467 8.24 5.032 7.728 4.68C7.216 4.328 6.70933 3.896 6.208 3.384C5.71733 2.872 5.24267 2.27467 4.784 1.592ZM0.88 4.344H4.64C5.51467 4.344 6.34133 4.39733 7.12 4.504C7.90933 4.6 8.63467 4.728 9.296 4.888L10.64 5.704L9.296 6.52C8.63467 6.68 7.90933 6.81333 7.12 6.92C6.34133 7.016 5.51467 7.064 4.64 7.064H0.88V4.344Z" fill="#003822"></path>
                       </svg>
                    </span>`;
        let BelowProductPrice = `<div class="custom-price"> <span class="custom_product_price"> ${targetElement.textContent}</span><span class="free-shipping">| Free shipping</span></div>`;
        const intervalId = setInterval(
          function (PriceHtml) {
            let PriceReplace = document.querySelector(
              '.cpb-add-to-cart-button'
            );
            if (PriceReplace) {
              clearInterval(intervalId);
              PriceReplace.innerHTML = PriceHtml;
              let ProductTitle = document.querySelector('.cpb-product-title');
              const tempContainer = document.createElement('div');
              tempContainer.innerHTML = BelowProductPrice;
              if (document.querySelector('.custom-price')) {
                document.querySelector(
                  '.custom-price'
                ).innerHTML = `<span class="custom_product_price"> ${targetElement.textContent}</span><span class="free-shipping">| Free shipping</span>`;
              } else {
                ProductTitle.parentNode.insertBefore(
                  tempContainer,
                  ProductTitle.nextSibling
                );
              }
            }
          },
          200,
          PriceHtml
        );
      }
    }
  };

  let observer = new MutationObserver(contentObserver);
  observer.observe(document.body, config);
});

document.body.addEventListener('DOMNodeInserted', function (e) {
  if (
    e.target &&
    e.target.classList &&
    e.target.classList.contains('cpb-panels-container')
  ) {
    let addToCartButton = e.target.querySelector('.cpb-add-to-cart-button');
    if (addToCartButton) {
      let pTag = document.createElement('p');
      pTag.classList.add('life-insurance');
      let insuranceText = document.createTextNode(
        'Paying with life insurance? '
      );
      pTag.appendChild(insuranceText);
      let aTag = document.createElement('a');
      aTag.href = 'https://titancasket.com/pages/paying-casket-life-insurance';
      aTag.textContent = 'Start here';
      pTag.appendChild(aTag);
      addToCartButton.parentNode.insertBefore(
        pTag,
        addToCartButton.nextSibling
      );
      let PriceTag = document.createElement('p');
      pTag.classList.add('product-price');
    }
  }
});
